import { useMeta } from '@nuxtjs/composition-api';
import { mergeHeadItems } from '@/modules/common/utils/helpers';
import {
  generateNewsMediaOrganizationSchema,
  generateSiteNavigationElementSchema,
  generateWebsiteSchema,
  getSchemaHead,
} from '~/modules/common/utils/schemaUtils';
import { HOST_URL } from '~/constants/config';
import { getMetaOpenGraph, getMetaTwitter } from '~/modules/common/utils/metaUtils';

export function useKesfetMeta() {
  useMeta(() => {
    const title = 'Onedio Keşfet - Tüm İçerikler';
    const description =
      'Onedio’nun geniş içerik yelpazesini kendi ilgi alanlarınıza göre filtreleyin. İstediğiniz türde içerikler, videolar ve daha fazlasına kolayca ulaşın!';
    const url = `${HOST_URL}/kesfet`;
    const imageUrl = 'https://static-onedio.s3.eu-west-1.amazonaws.com/img/png/kesfet-onedio.png';
    const descriptionMeta = { hid: 'description', name: 'description', content: description };
    // meta
    const meta = [
      descriptionMeta,
      ...getMetaOpenGraph({ url, description, title, imageUrl }),
      ...getMetaTwitter({ url, description, title, imageUrl }),
    ];
    // link
    const link = [{ hid: 'canonical', rel: 'canonical', href: url }];
    // schema
    const websiteSchema = generateWebsiteSchema();
    const newsMediaOrganization = generateNewsMediaOrganizationSchema();
    const siteNavigationElementSchema = generateSiteNavigationElementSchema();

    return mergeHeadItems(
      { title },
      { meta },
      { link },
      getSchemaHead(websiteSchema),
      getSchemaHead(newsMediaOrganization),
      getSchemaHead(siteNavigationElementSchema)
    );
  });
}
